import React from "react";
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

const useStyles = makeStyles(styles);

// Where the backend's PayPal views send the user back to
// (see backend/paypal_payments/views.py: /payment/<result>).
const RESULTS = {
  success: {
    color: "success",
    Icon: CheckCircleIcon,
    title: "Payment successful",
    body: (amount) =>
      amount
        ? `Thank you! Your payment of USD ${amount} has been received.`
        : "Thank you! Your payment has been received.",
  },
  cancelled: {
    color: "warning",
    Icon: CancelIcon,
    title: "Payment cancelled",
    body: () => "No payment was made. You can try again whenever you're ready.",
  },
  error: {
    color: "danger",
    Icon: ErrorOutlineIcon,
    title: "Payment failed",
    body: () =>
      "Your payment could not be completed and you have not been charged. Please try again, or contact support if it keeps happening.",
  },
};

export default function PaymentResultPage({ match, location, history }) {
  const [cardAnimation, setCardAnimation] = React.useState("cardHidden");
  const classes = useStyles();

  React.useEffect(() => {
    const id = setTimeout(() => setCardAnimation(""), 700);
    return () => clearTimeout(id);
  }, []);

  const params = new URLSearchParams(location.search);
  const result = RESULTS[match.params.result] || RESULTS.error;
  const amount = params.get("amount");

  React.useEffect(() => {
    // PayPal's raw error text is for debugging only, never shown to the user.
    const message = new URLSearchParams(location.search).get("message");
    if (match.params.result === "error" && message) {
      console.error("[Payment] PayPal error:", message);
    }
  }, [match.params.result, location.search]);

  const { Icon } = result;

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={6}>
          <Card className={classes[cardAnimation]}>
            <CardHeader
              className={`${classes.cardHeader} ${classes.textCenter}`}
              color={result.color}
            >
              <Icon style={{ fontSize: 40, color: "#fff" }} />
              <h4 className={classes.cardTitle}>{result.title}</h4>
            </CardHeader>
            <CardBody className={classes.textCenter}>
              <p>{result.body(amount)}</p>
            </CardBody>
            <CardFooter className={classes.justifyContentCenter}>
              <Button color="rose" onClick={() => history.push("/singles/dashboard")}>
                Go to dashboard
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
